import { useCallback, useMemo } from 'react'

import { useLocalStorage } from '@uidotdev/usehooks'
import { tableInitialState } from '../FullTable/FullTable'

export const useInitialTableState = (name, userInitialState) => {
  const [initialState, setInitialState] = useLocalStorage(name, { ...tableInitialState, ...userInitialState })

  return [{ ...tableInitialState, ...initialState }, setInitialState]
}
